import ValueFactory from '../../util/ValueFactory';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { AiModelActions } from '../actions/AiModelActions';
import { MLOpsModel } from '../../domain/mlops/MLOpsDomains';

export interface AiModelState {
  aiModel: MLOpsModel;
  trainingFile: File | null;
  validationFile: File | null;
  isUpdate: boolean;
}

const initialState: AiModelState = {
  aiModel: ValueFactory.initializeAiModel(),
  isUpdate: false,
  trainingFile: null,
  validationFile: null,
};

export const aiModelReducer = (state = initialState, action: ReduxBaseAction<any, AiModelActions>) => {
  switch (action.type) {
    case 'CHANGE_AI_MODEL':
      return { ...state, aiModel: action.payload };
    case 'CHANGE_AI_MODEL_IS_UPDATE':
      return { ...state, isUpdate: action.payload };
    case 'CLEAR_AI_MODEL':
      return { ...state, aiModel: ValueFactory.initializeAiModel(), aiModelSchema: null, dependencies: [], isUpdate: false };
    case 'CHANGE_AI_MODEL_TRAINING_FILE':
      return { ...state, trainingFile: action.payload };
    case 'CHANGE_AI_MODEL_VALIDATION_FILE':
      return { ...state, validationFile: action.payload };
    default:
      return state;
  }
};
